import { ArticlesPage } from 'routes/Articles'
import { getArticles } from 'helpers/strapi'
import { ArticleType } from 'helpers/strapi/types'
import { BLOG_REVALIDATE_TIME, HIDDEN_CATEGORIES } from 'routes/constants'

export default function Articles({ articles }: { articles: ArticleType[] }) {
  return <ArticlesPage articles={articles} />
}

export async function getStaticProps() {
  const articles = await getArticles({
    sort: 'date:desc',
    filters: {
      category: {
        slug: {
          $ne: HIDDEN_CATEGORIES,
        },
      },
    },
  })
  return {
    props: {
      articles,
    },
    revalidate: BLOG_REVALIDATE_TIME, // In seconds
  }
}
